/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Channeldescription1Inputs */

const en_channeldescription1 = /** @type {(inputs: Channeldescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Broadcast one-way announcements to your subscribers`)
};

const de_channeldescription1 = /** @type {(inputs: Channeldescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sende einseitige Ankündigungen an deine Abonnenten`)
};

/**
* | output |
* | --- |
* | "Broadcast one-way announcements to your subscribers" |
*
* @param {Channeldescription1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const channeldescription1 = /** @type {((inputs?: Channeldescription1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Channeldescription1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_channeldescription1(inputs)
	return de_channeldescription1(inputs)
});
export { channeldescription1 as "channelDescription" }